import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sd-wishlist-content-error',
  templateUrl: './wishlist-content-error.component.html',
  styleUrls: ['./wishlist-content-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WishlistContentErrorComponent {}
